import { useCallback, useEffect, useRef } from 'react';
import { registerUnauthorizedHandler } from '@/api/unauthorizedResponse';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import useAccessTokenExpiration from '@/modules/auth/hooks/useAccessTokenExpiration';
import { LoginPath } from '@/modules/auth/paths';
import { useLocation, useNavigate } from 'react-router-dom';

const AuthUnauthorizedHandler = () => {
  const { accessToken, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const sessionExpirationHandled = useRef(false);

  const expireSession = useCallback(() => {
    if (sessionExpirationHandled.current) {
      return;
    }

    sessionExpirationHandled.current = true;
    void logout();

    if (location.pathname !== LoginPath) {
      navigate(LoginPath, {
        replace: true,
        state: { sessionExpired: true },
      });
    }
  }, [location.pathname, logout, navigate]);

  useEffect(() => {
    sessionExpirationHandled.current = false;
  }, [accessToken]);

  useEffect(() => registerUnauthorizedHandler(expireSession), [expireSession]);

  useAccessTokenExpiration(accessToken, expireSession);

  return null;
};

export default AuthUnauthorizedHandler;
